export const theme = {
  fontFamily: {
    sans: `'Interstate', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
  },

  fontSizes: {
    sm: 12,
    md: 14,
    lg: 18
  },

  colors: {
    text: '#fafafa',

    neutral: {
      50: '#fafafa',
      100: '#f4f4f4',
      200: '#e4e4e7',
      300: '#d4d4d8',
      400: '#a1a1aa',
      500: '#71717a',
      600: '#52525b',
      700: '#3f3f46',
      800: '#27272a',
      900: '#18181b'
    },

    indigo: {
      50: '#eef2ff',
      100: '#e0e7ff',
      200: '#c7d2fe',
      300: '#818cf8',
      400: '#6366f1',
      500: '#4f46e5',
      600: '#7338ca',
      700: '#4338ca',
      800: '#3730a3',
      900: '#312e81'
    },

    green: {
      500: '#00C165'
    },

    blue: {
      500: '#0094FF'
    },

    red: {
      500: '#ef4444'
    },

    yellow: {
      500: '#EAB308'
    }
  },

  zIndex: {
    boardWorkspace: 900,
    boardToolbar: 1000,
    boardToolbarIcon: 1010,
    boardToolbarHoveredIcon: 1020,
    editPopover: 1100,
    userDropdown: 1200,
    heroSelector: 1300,
    popover: 1500
  }
}
